import { cn } from '@pma/utils/helpers'
import { ComponentPropsWithoutRef, createContext, useContext, useId } from 'react'

const TabsContext = createContext<{ activeTab: number }>({ activeTab: 0 })

export function Tabs({
  activeTab,
  className,
  ...props
}: ComponentPropsWithoutRef<'div'> & { activeTab: number }) {
  return (
    <TabsContext.Provider value={{ activeTab }}>
      <div className={cn('space-y-4', className)} {...props} />
    </TabsContext.Provider>
  )
}

export function TabsList({ className, ...props }: ComponentPropsWithoutRef<'div'>) {
  return (
    <div
      className={cn('flex border-b border-gray-200', className)}
      {...props}
    />
  )
}

export function TabsTrigger({
  className,
  active,
  ...props
}: ComponentPropsWithoutRef<'button'> & { active?: boolean }) {
  return (
    <button
      className={cn(
        'px-4 py-2 text-sm font-medium border-b-2 -mb-px transition-colors',
        active
          ? 'border-blue-500 text-blue-600'
          : 'border-transparent text-gray-500 hover:text-gray-700',
        className
      )}
      {...props}
    />
  )
}

export function TabsContent({
  tabIndex,
  className,
  ...props
}: ComponentPropsWithoutRef<'div'> & { tabIndex: number }) {
  const { activeTab } = useContext(TabsContext)
  if (tabIndex !== activeTab) return null
  return <div className={className} {...props} />
}